import { LegalUserState, LEGAL_USER_FEATURE_KEY } from "./legalUser.slice";
import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../index";

const getLegalUserState = (rootState: StoreState): LegalUserState => rootState[LEGAL_USER_FEATURE_KEY];

const getRegistrationData = createSelector(getLegalUserState, (state: LegalUserState) => state.registrationData);

const getLoading = createSelector(getLegalUserState, (state: LegalUserState) => state.loading);

const getError = createSelector(getLegalUserState, (state: LegalUserState) => state.error);

const getIdentificationData = createSelector(getLegalUserState, (state: LegalUserState) => state.identificationData);

const getIdentificationLoading = createSelector(getLegalUserState, (state: LegalUserState) => state.identificationLoading);

const getIdentificationError = createSelector(getLegalUserState, (state: LegalUserState) => state.identificationError);

const getAccessToken = createSelector(getLegalUserState, (state: LegalUserState) => state.identificationData?.result?.result?.token);

export const legalUserSelectors = {
  getLegalUserState,
  getRegistrationData,
  getLoading,
  getError,
  getIdentificationData,
  getIdentificationLoading,
  getIdentificationError,
  getAccessToken,
};